import {Component, Input, OnChanges} from '@angular/core';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent implements OnChanges {
  items:MenuItem[] | undefined;
  home: MenuItem | undefined;
  @Input() label = '';
  @Input() labels: string[] = [];

  ngOnChanges() {
    const breadcrumbLabels = this.labels.length ? this.labels : [this.label];

    this.items = breadcrumbLabels.map((label) => ({ label }));
    this.home = {icon: 'pi pi-home', routerLink: '/inicio'}
  }
}
